import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { Modules, Pages, VoiceModules } from '../core/constants/shared.constants';
import { SharedModule } from '../shared/shared.module';


import { VoiceComponent } from './voice.component';

const routes: Routes = [
  {
    path: 'overview',
    component: VoiceComponent,
    loadChildren: () => import('../voice/dashboard/dashboard.module').then(mod => mod.DashboardModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceOut
    }
  },
  {
    path: Pages.SendRequest,
    component: VoiceComponent,
    loadChildren: () => import('../voice/send-request/send-request.module').then(mod => mod.SendRequestModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceRequest

    }
  },
  {
    path: Pages.GetStatus,
    component: VoiceComponent,
    loadChildren: () => import('../voice/request-info/request-info.module').then(mod => mod.RequestInfoModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceInfo
      
    }
  },
  {
    path: Pages.HangupCause,
    component: VoiceComponent,
    loadChildren: () => import('../voice/voice-hangup-cause/voice-hangup-cause.module').then(mod => mod.VoiceHangupCauseModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.HangupCause

    }
  },
  {
    path: Pages.Status,
    component: VoiceComponent,
    loadChildren: () => import('../voice/voice-status/voice-status.module').then(mod => mod.VoiceStatusModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceStatus
    }
  },
  {
    path: 'channel-behavior',
    component: VoiceComponent,
    loadChildren: () => import('../voice/channel-behavior/channel-behavior.module').then(mod => mod.ChannelBehaviorModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.ChannelBehavior
    }
  },
  {
    path: 'tts-voice-id',
    component: VoiceComponent,
    loadChildren: () => import('../voice/tts-voice-id/tts-voice-id.module').then(mod => mod.TtsVoiceIdModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceId
    }
  },
  {
    path: 'languages-code',
    component: VoiceComponent,
    loadChildren: () => import('../voice/transcribe-language/transcribe-language.module').then(mod => mod.TranscribeLanguageModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.LanguageCode
    }
  },
  {
    path: 'hangup',
    component: VoiceComponent,
    loadChildren: () => import('../voice/hangup-request/hangup-request.module').then(mod => mod.HangupRequestModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.Hangup
    }
  },
  {
    path: 'archive',
    component: VoiceComponent,
    loadChildren: () => import('./archive-voice-request/archive-voice-request.module').then(mod => mod.ArchiveVoiceRequestModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.Cancel
    }
  },
  {
    path: 'cancel',
    component: VoiceComponent,
    loadChildren: () => import('./cancel-voice-request/cancel-voice-request.module').then(mod => mod.CancelVoiceRequestModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.Cancel
    }
  },
  {
    path: 'interfere',
    component: VoiceComponent,
    loadChildren: () => import('../voice/interfere/interfere.module').then(mod => mod.InterfereModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.Interfere
    }
  },
  {
    path: 'external-action',
    component: VoiceComponent,
    loadChildren: () => import('../voice/external-action/external-action.module').then(mod => mod.ExternalActionModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.ExternalActions
    }
  },
  //{
  //  path: 'inbound-history',
  //  component: VoiceComponent,
  //  loadChildren: () => import('../voice/inbound-history/inbound-history.module').then(mod => mod.InboundHistoryModule),
  //  data: {
  //    module: Modules.VoiceOut,
  //    menuTitleTitle: VoiceModules.InboundHistory
  //  }
  //},
  {
    path: 'recording-storage',
    component: VoiceComponent,
    loadChildren: () => import('../voice/recording-storage-period/recording-storage-period.module').then(mod => mod.RecordingStoragePeriodModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.RecordStorage
    }
  },
  {
    path: 'how-to',
    component: VoiceComponent,
    loadChildren: () => import('../voice/how-to/how-to.module').then(mod => mod.HowToModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.HowTo
    }
  },
  {
    path: Pages.StorageDetails,
    component: VoiceComponent,
    loadChildren: () => import('../voice/storage-details/storage-details.module').then(mod => mod.StorageDetailsModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.VoiceInfo
    }
  },
  {
    path: Pages.RephraseInstructions,
    component: VoiceComponent,
    loadChildren: () => import('../voice/rephrase-instructions/rephrase-instructions-voice-out.module').then(mod => mod.RephraseInstructionsVoiceOutboundModule),
    data: {
      module: Modules.VoiceOut,
      menuTitle: VoiceModules.RephraseInstructions
    }
  },
  {
    path: '',
    redirectTo: 'overview'
  },
  {
    path: '**',
    redirectTo: 'overview'
  }
]

@NgModule({
  declarations: [VoiceComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    VoiceComponent,
    RouterModule
  ]
})
export class VoiceRoutingModule { }
